/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import type { SnackbarProps, SnackbarStatesType } from '../_props';

/**
 * Typings
 */

type TUseSnackbar = Pick<SnackbarProps, 'state' | 'float' | 'fadeOutTiming'>;

/**
 * Hook
 */

export const useSnackbar = ({ state = 'Loading', float, fadeOutTiming }: TUseSnackbar) => {
  const [visible, setVisible] = useState<boolean | null>(null);
  const [display, setDisplay] = useState(true);

  const [snackbarState, setSnackbarState] = useState<SnackbarStatesType>(state);

  /**
   * Update Snackbar state
   */

  useEffect(() => {
    setSnackbarState(state);
  }, [state]);

  /**
   * Handle Snackbar visibility
   */

  useEffect(() => {
    if (snackbarState === 'Loading') return;

    if (snackbarState === 'Closed') {
      setTimeout(() => setDisplay(false), 500);

      if (!visible || !float) return;
    }

    setVisible(snackbarState === 'Visible');
  }, [snackbarState, visible, float]);

  /**
   * Handle Snackbar automatic fade-out
   */

  useEffect(() => {
    if (!float || !fadeOutTiming) return;

    setTimeout(() => setSnackbarState('Closed'), fadeOutTiming * 1000);
  }, [fadeOutTiming, float]);

  /**
   * Return
   */

  return {
    visible,
    display,
    snackbarState,
  };
};

export default useSnackbar;
